import { useState } from 'react';

type ChangeHandler = (_: React.SyntheticEvent, newValue: string) => void;

export const useTabs = (defaultTab: string): [string, ChangeHandler] => {
    const [value, setValue] = useState<string>(defaultTab);

    const handleChange = (_: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return [value, handleChange];
};
